import React from "react";
import { NotImplemented } from "pages/PayRoll/Shared/NotImplemented";

// Placeholder until Failed / Pending Payments is built. Reached from
// Payroll > Disbursement > Failed / Pending Payments in the sidebar flyout.
export const DisbursementFailedPendingPayments = () => <NotImplemented title="Failed / Pending Payments" />;
